import React from 'react'
import { generatePath, useNavigate, useParams } from 'react-router-dom'
import { ALTER_ERROR, useSnackbar } from 'storfox-snackbar'
import { prop, propOr } from 'ramda'

import { DashboardLayout } from '~/components/Layouts'
import * as ROUTES from '~/constants/routes'
import * as NAV from '~/constants/nav-titles'
import ErrorLink from '~/components/ErrorLink'
import { INTEGRATION_TABS } from '~/constants/tabs'
import useMessages from '~/hooks/useMessages'

import { useIntegrationHistory, usePublicApiDetail, usePublicApiRemove, usePublicApiUpdate } from '../../hooks'
import ApiIntegrationUpdateForm from '../../components/Api/ApiIntegrationUpdateForm'

function ApiIntegrationUpdateContainer () {
  const { guid, tab } = useParams()

  const snackbar = useSnackbar()
  const navigate = useNavigate()
  const messages = useMessages()
  const publicApiDetail = usePublicApiDetail(guid)
  const publicApiUpdate = usePublicApiUpdate(guid)
  const publicApiRemove = usePublicApiRemove()

  const historyAutoSend = Boolean(guid && tab === INTEGRATION_TABS.LOGS)
  const integrationHistory = useIntegrationHistory(guid, historyAutoSend)

  const title = prop('name', publicApiDetail.detail)
  const type = propOr('', 'type', publicApiDetail.detail)

  const detailPath = generatePath(ROUTES.INTEGRATION_UPDATE_PATH, { guid, type, tab: INTEGRATION_TABS.GENERAL })

  const handleSubmit = formValues =>
    publicApiUpdate.update(formValues)
      .then(() => {
        snackbar({ message: messages.UPDATE_SUCCESS })
        navigate(detailPath)
      })
      .catch(error => {
        const message = <ErrorLink error={error} />
        snackbar({ message, type: ALTER_ERROR })
      })

  const isLoading = (
    publicApiDetail.isLoading ||
    publicApiUpdate.isLoading
  )

  const handleRemove = () =>
    publicApiRemove.delete({ guids: [guid] })
      .then(() => navigate(ROUTES.INTEGRATION_LIST_PATH, { replace: true }))

  const breadcrumbs = { title }

  return (
    <DashboardLayout
      isLoading={publicApiDetail.isLoading}
      activeNav={NAV.INTEGRATION}
      breadcrumbs={breadcrumbs}
    >
      <ApiIntegrationUpdateForm
        isLoading={isLoading}
        pageTitle={title}
        pageTitleLoading={publicApiDetail.isLoading}
        onSubmit={handleSubmit}
        onRemove={handleRemove}
        initialValues={publicApiDetail.detail}
        history={integrationHistory}
      />
    </DashboardLayout>
  )
}

export default ApiIntegrationUpdateContainer
